import { useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { SearchSchema, TSearchSchema } from './SearchSchema'

interface IUseSearchFormProps extends Omit<UseFormOptions<TSearchSchema>, 'resolver'> {}

export const useSearchForm = ({ ...props }: IUseSearchFormProps) => {
  return useForm<TSearchSchema>({
    resolver: yupResolver(SearchSchema),
    ...props,
  })
}
